export const DemoSectionText = {
  invite: 'Integrate aircheckr into your services and truly improve the health and user experience of your customers',
  cta: 'Sign up now',
}



// WEBPACK FOOTER //
// ./src/input-text/en/demosection.js